import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const ButtonLink = ({ children, to, text, color, ...props }) => {
  return (
    <div className="box-button">
      <Link
        className="button-voucher"
        style={{ background: color || 'var(--button_facilities)' }}
        to={to}
        {...props}
      >
        {children || text}
      </Link>
    </div>
  );
};

export default ButtonLink;
